import LegalDisclaimer from './LegalDisclaimer'

export default LegalDisclaimer
